// single source of truth for a CAD's cost and term on the new CADs page, so the
// card footer (Cost / Wholesale / MSRP) and the per-order margins can't disagree
// about what "cost" means.
// cost: fc (future_ats_ave_cost) -> ac (ave_cost) -> ATS-rep (cents -> dollars).
// term: ATS-rep term -> cad.at.
const costValue = (value) => {
  let number = Number(value)
  return isNaN(number) || number == 0 ? null : number
}

const cadCost = (cad, atsRepData) => {
  return costValue(cad.fc) || costValue(cad.ac) || (atsRepData == null ? null : costValue(atsRepData.c / 100.0))
}

const cadTerm = (cad, atsRepData) => {
  return (atsRepData == null ? null : atsRepData.a) || cad.at
}

export {costValue, cadCost, cadTerm}
